import React from 'react';

// Renders one row per feature: an icon, a title, and a supporting line. Purely
// presentational — no data fetching, no auth calls. The icon is decorative
// (alt="") because the adjacent title already carries the meaning.
export default function InvitationFeatureList({ features }) {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {features.map(({ icon, title, body }) => (
                <div key={icon + title} className="flex items-start gap-3">
                    <img
                        src={`/images/icons/${icon}.svg`}
                        alt=""
                        width="24"
                        height="24"
                        className="h-6 w-6 flex-shrink-0"
                    />
                    <div>
                        <p className="text-sm font-medium text-[color:var(--text-primary)]">{title}</p>
                        <p className="text-sm text-[color:var(--text-muted)]">{body}</p>
                    </div>
                </div>
            ))}
        </div>
    );
}
